'use client';

import type { MaterialWithSoftTag } from '@/features/match-maker/utils/match-maker.types';
import {
  ProductionReportMeasurementEntryEnum,
  type ProductionPeriod,
  type ProductionReportMeasurementInput,
} from '../../utils/types';
import CalculationCardForTable from '../../components/calculation-card-for-table';

const CalculationTableCell: React.FC<{
  tags: Array<MaterialWithSoftTag> | null;
  measurement: ProductionReportMeasurementInput | null;
  productionPeriod?: ProductionPeriod;
  onDetail?: () => void;
}> = ({ tags, measurement, productionPeriod, onDetail }) => {
  const selectedTag = tags?.find(tag => tag.id === measurement?.tag_id);
  if (!measurement) {
    return null;
  }
  return (
    <CalculationCardForTable
      title={selectedTag?.tag_name || 'Manual correction'}
      value={measurement.quantity || 0}
      unit={measurement.unit || ''}
      priority={measurement.tag_id === null ? 0 : selectedTag?.priority || 0}
      timestamp={measurement.timestamp || productionPeriod?.end_time || '-'}
      className="border border-gray-300 rounded-lg bg-white min-w-[256px] max-w-[350px] md:min-w-[350px] md:max-w-[450px]"
      {...((measurement?.entry_type ||
        ProductionReportMeasurementEntryEnum.TAG) ===
        ProductionReportMeasurementEntryEnum.TAG && { onDetail })}
    />
  );
};

export default CalculationTableCell;
